export const ApryseProductionKey =
    "Tietoevry AB  fka Tieto Sweden AB :OEM:Family care::B+:AMS(20260910):DCB554220457F60A4360B13AC9A273F260616F5CD728BD7B7C1CAC01FD7248B0528A31F5C7";
